<template>
  <zj-layout-container
    v-loading="!IsNoLoading && loading"
    :element-loading-text="loadingText"
    class="eventinfocss bgcolor"
  >
    <zj-layout-main>
      <div class="zj-layout-main-content scrollable">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="16rem"
        >
          <el-collapse v-model="activeNames">
            <el-collapse-item name="EventInfo" v-if="EventInfo">
              <template slot="title">
                <i class="header-icon el-icon-arrow-down"></i>
                <span class="spantitle">事件信息：</span>
              </template>
              <el-form-item label="事件编号" style="display: inline-block">
                <el-input v-model="ruleForm.eventNo" disabled="true"></el-input>
              </el-form-item>
              <el-form-item
                label="事件名称"
                prop="eventName"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.eventName"
                  :disabled="EventInfoEdit"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="事件级别"
                prop="eventLevel"
                style="display: inline-block"
              >
                <el-select
                  v-model="ruleForm.eventLevel"
                  :disabled="EventInfoEdit"
                >
                  <el-option
                    v-for="item in EventLevelOptions"
                    :key="item.code"
                    :label="item.value"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="事件类型"
                prop="eventType"
                style="display: inline-block"
              >
                <el-select
                  v-model="ruleForm.eventType"
                  :disabled="EventInfoEdit"
                >
                  <el-option
                    v-for="item in EventTypeOptions"
                    :key="item.code"
                    :label="item.value"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="接报方式"
                prop="receiveWay"
                style="display: inline-block"
              >
                <el-select
                  v-model="ruleForm.receiveWay"
                  :disabled="EventInfoEdit"
                >
                  <el-option
                    v-for="item in EventWaypeOptions"
                    :key="item.code"
                    :label="item.value"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="接报时间"
                prop="happenTime"
                style="display: inline-block"
                v-if="ruleForm.createdate"
              >
                <el-date-picker
                  type="datetime"
                  placeholder="选择日期"
                  v-model="ruleForm.createdate"
                  disabled
                  :clearable="false"
                  format="yyyy-MM-dd HH:mm:ss" 
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
              <el-form-item
                label="事发时间"
                prop="happenTime"
                style="display: inline-block"
              >
                <el-date-picker
                  type="datetime"
                  placeholder="选择日期"
                  v-model="ruleForm.happenTime"
                  :disabled="EventInfoEdit"
                  :clearable="false"
                  format="yyyy-MM-dd HH:mm:ss" 
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
              <el-form-item
                label="经度"
                prop="longitude"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.longitude"
                  :disabled="true"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="纬度"
                prop="latitude"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.latitude"
                  :disabled="true"
                  style="width: 34rem"
                ></el-input>
                <ZjLngLatSelect
                  :point_lat="ruleForm.latitude"
                  :point_lng="ruleForm.longitude"
                  @onGotLngLat="onGotLngLat"
                  style="margin-left: 1.5rem"
                ></ZjLngLatSelect>
              </el-form-item>
              <el-form-item
                label="事发地点"
                prop="eventAddress"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.eventAddress"
                  :disabled="EventInfoEdit"
                  style="width: 98rem"
                ></el-input>
              </el-form-item>
              <el-row>
                <el-form-item
                  label="事件描述"
                  prop="eventDesc"
                  style="display: inline-block"
                >
                  <el-input
                    type="textarea"
                    v-model="ruleForm.eventDesc"
                    :disabled="EventInfoEdit"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-form-item
                label="总结说明："
                style="display: inline-block; margin-top: 2rem"
                v-if="EventSummeryShow"
              >
                <el-input
                  type="textarea"
                  :disabled="true"
                  v-model="ruleForm.summaryDesc"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="归档描述："
                style="display: inline-block"
                v-if="EventSummeryShow"
              >
                <el-input
                  type="textarea"
                  :disabled="true"
                  v-model="ruleForm.placeFileDesc"
                ></el-input>
              </el-form-item>
            </el-collapse-item>
            <el-collapse-item name="EventSource" v-if="EventSource">
              <template slot="title">
                <i class="header-icon el-icon-arrow-down"></i>
                <span class="spantitle">事件来源：</span>
              </template>

              <el-form-item
                label="上报人姓名"
                prop="reportName"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.reportName"
                  :disabled="EventSourceEdit"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="上报单位"
                prop="reportDept"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.reportDept"
                  :disabled="EventSourceEdit"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="联系方式"
                prop="reportContact"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.reportContact"
                  :disabled="EventSourceEdit"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="上报时间"
                prop="reportTime"
                style="display: inline-block"
              >
                <el-date-picker
                  type="datetime"
                  placeholder="选择日期"
                  v-model="ruleForm.reportTime"
                  :disabled="EventSourceEdit"
                  :clearable="false"
                  format="yyyy-MM-dd HH:mm:ss" 
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
            </el-collapse-item>
            <el-collapse-item name="EventAffect" v-if="EventAffect">
              <template slot="title">
                <i class="header-icon el-icon-arrow-down"></i>
                <span class="spantitle">事件影响：</span>
              </template>

              <el-form-item
                label="死亡人数"
                prop="deathNum"
                style="display: inline-block"
              >
                <el-input
                  v-model.number="ruleForm.deathNum"
                  :disabled="EventAffectEdit"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="受伤人数"
                prop="injuredNum"
                style="display: inline-block"
              >
                <el-input
                  v-model.number="ruleForm.injuredNum"
                  :disabled="EventAffectEdit"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="受困人数"
                prop="trappedNum"
                style="display: inline-block"
              >
                <el-input
                  v-model.number="ruleForm.trappedNum"
                  :disabled="EventAffectEdit"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="影响半径"
                prop="influenceRadius"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.influenceRadius"
                  :disabled="EventAffectEdit"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="经济损失"
                prop="economicLosses"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.economicLosses"
                  :disabled="EventAffectEdit"
                ></el-input>
              </el-form-item>
              <el-row>
                <el-form-item
                  label="已采取措施"
                  prop="measuresTaken"
                  style="display: inline-block"
                >
                  <el-input
                    type="textarea"
                    v-model="ruleForm.measuresTaken"
                    :disabled="EventAffectEdit"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item
                  label="当前救援情况"
                  prop="currentRescue"
                  style="display: inline-block"
                >
                  <el-input
                    type="textarea"
                    v-model="ruleForm.currentRescue"
                    :disabled="EventAffectEdit"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item
                  label="救援请求"
                  prop="rescueRequest"
                  style="display: inline-block"
                >
                  <el-input
                    type="textarea"
                    v-model="ruleForm.rescueRequest"
                    :disabled="EventAffectEdit"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item
                  label="备注"
                  prop="remark"
                  style="display: inline-block"
                >
                  <el-input
                    type="textarea"
                    v-model="ruleForm.remark"
                    :disabled="EventAffectEdit"
                  ></el-input>
                </el-form-item>
              </el-row>
            </el-collapse-item>
            <el-collapse-item name="EventConfirm" v-if="EventConfirm">
              <template slot="title">
                <i class="header-icon el-icon-arrow-down"></i>
                <span class="spantitle">事件核实：</span>
              </template>
              <el-row>
                <el-form-item
                  label="事件是否属实"
                  style="display: inline-block"
                >
                  <!-- <el-radio
                    v-model="ruleForm.beTrue"
                    :label="1"
                    :disabled="EventConfirmEdit"
                    >是</el-radio
                  >
                  <el-radio
                    v-model="ruleForm.beTrue"
                    :label="0"
                    :disabled="EventConfirmEdit"
                    >否</el-radio
                  > -->
                  <el-radio
                    v-for="item in beTrueOptions"
                    :key="item.code"
                    v-model="ruleForm.beTrue"
                    :label="item.code"
                    :disabled="EventConfirmEdit"
                    >{{item.value}}</el-radio
                  >
                </el-form-item>
              </el-row>
              <el-form-item label="事件级别" style="display: inline-block">
                <el-select
                  v-model="ruleForm.verifyEventLevel"
                  :disabled="EventConfirmEdit"
                >
                  <el-option
                    v-for="item in EventLevelOptions"
                    :key="item.code"
                    :label="item.value"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="事件类型"
                prop="eventType"
                style="display: inline-block"
              >
                <el-select
                  v-model="ruleForm.verifyEventType"
                  :disabled="EventConfirmEdit"
                >
                  <el-option
                    v-for="item in EventTypeOptions"
                    :key="item.code"
                    :label="item.value"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-row>
                <el-form-item label="事发地点" style="display: inline-block">
                  <el-input
                    v-model="ruleForm.verifyEventAddress"
                    :disabled="EventConfirmEdit"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="补充说明" style="display: inline-block">
                  <el-input
                    type="textarea"
                    v-model="ruleForm.supplementary"
                    :disabled="EventConfirmEdit"
                  ></el-input>
                </el-form-item>
              </el-row>
            </el-collapse-item>
            <el-collapse-item name="EventReport" v-if="EventReport">
              <template slot="title">
                <i class="header-icon el-icon-arrow-down"></i>
                <span class="spantitle">事件上报：</span>
              </template>
              <el-tabs
                class="custom-tabs"
                v-model="editableTabsValue"
                @edit="handleTabsEdit"
                :editable="editable"
              >
                <el-tab-pane
                  :key="item.name"
                  v-for="item in editableTabs"
                  :label="item.title"
                  :name="item.name"
                >
                  <ReportEventTable
                    :ref="item.name"
                    :reportObj="item.reportObj"
                    :editable="!editable"
                  ></ReportEventTable>
                </el-tab-pane>
              </el-tabs>
            </el-collapse-item>
          </el-collapse>
        </el-form>
        <slot name="default"></slot>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <div v-if="!IsOnlyView">
        <div class="button-container">
          <el-button v-if="isTransferEmergency" @click="onBack()"
            >返回</el-button
          >
          <el-button v-if="IsAdd" type="primary" @click="submitForm(1)"
            >提交</el-button
          >

          <template v-if="!IsAdd">
            <el-button @click="onBack()">返回</el-button>
            <el-button type="primary" v-if="IsConfirm" @click="submitComfirm(2)"
              >核实</el-button
            >
            <el-button type="primary" v-if="IsReport" @click="submitReport(3)"
              >确认上报</el-button
            >
            <el-button type="primary" v-if="fasle" @click="startPlan()"
              >启动应急</el-button
            >
          </template>
        </div>
      </div>
    </zj-layout-footer>
    <el-dialog
      title="启动应急"
      :visible.sync="dialogOpts.dialogPlanTableVisible"
    >
      <EventPlan
        :viewData="dialogOpts.rowData"
        @cancel="dialogPlanCancel"
        @ok="dialogPlanOk"
        @search="search"
      ></EventPlan>
    </el-dialog>
  </zj-layout-container>
</template>
<script>
import ZJApp from "../../../../../app";
import earlyMsgApi from "../../../../../../api/src/earlyMsg.js";
import ReportEventTable from "./ReportEventTable.vue";
import EventPlan from "./EventPlan.vue";
import { process, getMessageById } from "@/api/src/message";
const utils = ZJApp.ZJUtils;

import { getDictionary } from "@/api/src/emergency_common";
import { save, update, detail } from "@/api/src/emergency_event";
import { batchSubmit, list } from "@/api/src/emergency_report";

import dayjs from 'dayjs'

export default {
  props: {
    EventInfo: { type: Boolean, default: true }, //是否显示事件信息
    EventInfoEdit: { type: Boolean, default: false }, //是否能编辑事件信息
    EventSource: { type: Boolean, default: true }, //是否显示事件来源
    EventSourceEdit: { type: Boolean, default: false }, //是否能编辑事件来源
    EventAffect: { type: Boolean, default: true }, //是否显示事件影响
    EventAffectEdit: { type: Boolean, default: false }, //是否能编辑事件影响
    EventConfirm: { type: Boolean, default: true }, //是否显示事件确认
    EventConfirmEdit: { type: Boolean, default: false }, //是否能编辑事件确认
    EventReport: { type: Boolean, default: true }, //是否显示事件上报
    IsAdd: { type: Boolean, default: false },
    IsConfirm: { type: Boolean, default: false },
    IsReport: { type: Boolean, default: false },
    editable: { type: Boolean, default: false },
    IsOnlyView: { type: Boolean, default: false },
    IsNoLoading: { type: Boolean, default: false }, //是否显示加载框
    EventSummeryShow: { type: Boolean, default: false }, //是否显示归档总结
    activeNames: {
      type: Object,
      default: function () {
        return [
          "EventInfo",
          "EventSource",
          "EventAffect",
          "EventConfirm",
          "EventReport",
        ];
      },
    },
    Status: { type: Number },
  },
  components: {
    ReportEventTable,
    EventPlan,
  },
  data() {
    return {
      loading: false,
      loadingText: "加载中",
      dialogOpts: {
        dialogPlanTableVisible: false,
        rowData: null,
      },
      EventTypeOptions: [],
      EventLevelOptions: [],
      EventWaypeOptions: [],
      beTrueOptions:[],
      ruleForm: {
        eventNo:
          "" +
          new Date().getFullYear() +
          (new Date().getMonth() + 1) +
          new Date().getDate() +
          new Date().getHours() +
          new Date().getMinutes() +
          new Date().getSeconds() +
          new Date().getMilliseconds(),
        eventName: "",
        eventLevel: null,
        eventType: null,
        id: "",
        receiveWay: null,
        happenTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        eventAddress: "",
        eventDesc: "",
        reportName: "",
        reportDept: "",
        reportContact: "",
        reportTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        deathNum: 0,
        injuredNum: 0,
        trappedNum: 0,
        influenceRadius: "",
        economicLosses: "",
        measuresTaken: "",
        currentRescue: "",
        rescueRequest: "",
        remark: "",
        beTrue: 1,
        status: 1,
        longitude: 0,
        latitude: 0,
      },
      rules: {
        eventName: [{ required: true, message: "请输入事件名称" }],
        eventAddress: [{ required: true, message: "请输入事发地点" }],
        reportName: [{ required: true, message: "请输入上报人姓名" }],
        reportContact: [{ required: true, message: "请输入联系方式" }],
        deathNum: [
          { required: true, message: "死亡人数不能为空" },
          { type: "number", message: "死亡人数必须为数字值" },
        ],
        injuredNum: [
          { required: true, message: "受伤人数不能为空" },
          { type: "number", message: "受伤人数必须为数字值" },
        ],
        trappedNum: [
          { required: true, message: "受困人数不能为空" },
          { type: "number", message: "受困人数必须为数字值" },
        ],
      },
      editableTabsValue: "report1",
      editableTabs: [],
      tabIndex: 1,
      alermInfo: {},
      isAlermEvent: false,
      msgInfo: {},
      AlerteLevelArr: [],
      AlertTypeArr: [],
      isTransferEmergency: false,
    };
  },
  methods: {
    init() {
      const id = this.$route.query.id;
      const AlarmId = this.$route.query.AlarmId;
      const MsgId = this.$route.query.MsgId;
      this.showLoading("加载中...");
      //判断来源是否是转应急事件，是的话在事件接报页添加返回
      if (AlarmId || MsgId) {
        this.isTransferEmergency = true;
      } else {
        this.isTransferEmergency = false;
      }
      utils
        .waitAll([
          getDictionary('emergency_event_type'),
          getDictionary('emergency_event_level'),
          getDictionary('emergency_receive_way'),
          getDictionary('yes_no'),
          id && id != ""
            ? detail( id )
            : Promise.resolve(undefined),
          // this.config.getUValue("AlarmSubsystem:AlarmType", ""),
          // AlarmId && AlarmId != ""
          //   ? new earlyMsgApi().GetItemById({ Id: AlarmId })
          //   : Promise.resolve(undefined),
          MsgId && MsgId != ""
            ? getMessageById(MsgId)
            : Promise.resolve(undefined),
        ])
        .then((r) => {
          const eventtypeconf = r[0];
          this.EventTypeOptions = eventtypeconf.data.records;
          if (this.EventTypeOptions) {
            this.ruleForm.eventType = this.EventTypeOptions[0].code;
          }

          const eventlevelconf = r[1];
          this.EventLevelOptions = eventlevelconf.data.records;
          if (this.EventLevelOptions) {
            this.ruleForm.eventLevel = this.EventLevelOptions[0].code;
          }

          const eventwayconf = r[2];
          this.EventWaypeOptions = eventwayconf.data.records;
          if (this.EventWaypeOptions)
            this.ruleForm.receiveWay = this.EventWaypeOptions[0].code;

          const beTrueConf = r[3];
          this.beTrueOptions = beTrueConf.data.records;

          const eventInfoResult = r[4];
          if (
            eventInfoResult &&
            eventInfoResult.data
          ) {
            const eventInfo = eventInfoResult.data;
            this.ruleForm = eventInfo;
            this.$emit("FinishTime", eventInfo.FinishTime);
            // this.ruleForm.beTrue = 2;
            this.ruleForm.verifyEventLevel =
              this.ruleForm.verifyEventLevel == null ||
              this.ruleForm.verifyEventLevel == ""
                ? this.ruleForm.eventLevel
                : this.ruleForm.verifyEventLevel;
            this.ruleForm.verifyEventType =
              this.ruleForm.verifyEventType == null ||
              this.ruleForm.verifyEventType == ""
                ? this.ruleForm.eventType
                : this.ruleForm.verifyEventType;
            //todo 获取上报信息
            this.GetEventReportList(id).then(() => {
              this.hideLoading();
            });
          } else {
            this.hideLoading();
          }

          // this.AlertTypeArr = r[5].JValue;
          // const warnInfoResult = r[6];
          // if (
          //   warnInfoResult &&
          //   warnInfoResult.data &&
          //   warnInfoResult.data.Data
          // ) {
          //   this.alermInfo = warnInfoResult.data.Data;
          //   if (this.isJson(this.alermInfo.Content)) {
          //     const deviceInfo = JSON.parse(this.alermInfo.Content);
          //     this.ruleForm.longitude = deviceInfo.longitude;
          //     this.ruleForm.latitude =
          //       deviceInfo.latitude || deviceInfo.Laitude;
          //   } else {
          //     this.ruleForm.longitude = this.alermInfo.longitude;
          //     this.ruleForm.latitude = this.alermInfo.latitude;
          //   }
          //   if (
          //     this.alermInfo.AlertType == 20 ||
          //     this.alermInfo.AlertType == 23
          //   ) {
          //     let content = this.alermInfo.Content;
          //     content = content.substring(
          //       content.indexOf("【") + 1,
          //       content.indexOf("】")
          //     );
          //     if (content) {
          //       this.findEquip(content);
          //     }
          //   }
          //   //事件名称-事件种类
          //   this.ruleForm.eventName = this.getType(this.alermInfo.AlertType);
          //   //接报方式-系统监测
          //   this.ruleForm.receiveWay = "EmergencyEventWay-XT";
          //   //事件级别-紧急事件
          //   this.ruleForm.eventLevel = "EmergencyEventLevel-3";

          //   this.ruleForm.eventAddress = this.alermInfo.Location;
          //   if (this.ruleForm.longitude && this.ruleForm.latitude) {
          //     this.getAddress(this.ruleForm.longitude, this.ruleForm.latitude);
          //   }
          //   this.ruleForm.happenTime = this.alermInfo.BeginDate;
          //   this.ruleForm.eventDesc = this.alermInfo.Content;

          //   //事件描述-【时间】【级别＋事件类型】【位置】【描述】
          //   this.ruleForm.eventDesc =
          //     this.formatDate(this.alermInfo.BeginDate) +
          //     "，" +
          //     this.getLevel(this.alermInfo.AlerteLevel) +
          //     this.ruleForm.eventName +
          //     "，" +
          //     (this.alermInfo.Location || "") +
          //     (this.alermInfo.Content || "");
          //   //报送人-系统
          //   this.ruleForm.reportName = this.alermInfo.Contact || "系统";
          //   this.ruleForm.reportContact = this.alermInfo.Phone;

          //   //报送时间-转应急的时间
          //   this.ruleForm.reportTime = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');

          //   this.ruleForm.AlarmId = AlarmId;
          //   this.isAlermEvent = true;
          // } else {
          //   this.hideLoading();
          // }

          const msgInfoResult = r[5];
          if (MsgId && msgInfoResult && msgInfoResult.data) {
            this.msgInfo = msgInfoResult.data;
            //事件名称-事件种类
            this.ruleForm.eventName =
              this.msgInfo.entityTypeTranslated +
              (this.msgInfo.warnTypeTranslated || "");
            //事件级别-紧急事件
            this.ruleForm.eventLevel = "EmergencyEventLevel-3";
            //接报方式-系统监测
            this.ruleForm.receiveWay = "EmergencyEventWay-XT";
            //事发时间-预警的时间
            this.ruleForm.happenTime = this.msgInfo.createTime;
            //事发地点-预警坐标
            this.ruleForm.longitude = this.msgInfo.longitude;
            this.ruleForm.latitude = this.msgInfo.latitude;
            if (this.ruleForm.longitude && this.ruleForm.latitude) {
              this.getAddress(this.ruleForm.longitude, this.ruleForm.latitude);
            }

            //事件描述-【时间】【级别＋事件类型】【位置】【描述】
            this.ruleForm.eventDesc =
              this.msgInfo.createTime +
              "，" +
              (this.msgInfo.processLevelTranslated || "") +
              this.msgInfo.entityTypeTranslated +
              (this.msgInfo.warnTypeTranslated || "") +
              "，" +
              (this.msgInfo.address || "") +
              (this.msgInfo.messageIntro || "");
            //报送人-系统
            this.ruleForm.reportName = "系统";
            //报送时间-转应急的时间
            this.ruleForm.reportTime = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
          }
        })
        .catch((e) => {
          console.log(e);
          this.hideLoading();
         
        });
    },
    //如果是环境监测的设备，按照名称获取经纬度
    findEquip(deviceName) {
      let params = {
        id: this.msgId,
        page: 1,
        size: 10,
        typeOneCode: "environmental_monitor",
        name: deviceName,
        model: "dustNoiseDevice",
      };
      const that = this;
      that.center = [];
      queryDevice(params).then((res) => {
        if (res && res.data.length > 0) {
          if (res.data[0].longitude && res.data[0].latitude) {
            this.ruleForm.longitude = res.data[0].longitude;
            this.ruleForm.latitude = res.data[0].latitude;
            this.getAddress(this.ruleForm.longitude, this.ruleForm.latitude);
          }
        }
      });
    },
    //日期列表展示格式
    formatDate(value) {
      // 获取单元格数据
      let data = value;
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    getLevel: function (value) {
      let result = "";

      switch (value) {
        case 3:
          result = "蓝色";
          break;
        case 5:
          result = "黄色";
          break;
        case 7:
          result = "橙色";
          break;
        case 10:
          result = "红色";
          break;
      }
      return result;
    },
    getType: function (value) {
      let AlertTypeArr = this.AlertTypeArr;
      let result = "";
      AlertTypeArr.forEach((item) => {
        if (value == item.Extend1) {
          result = item.Description;
        }
      });
      return result;
    },
    //根据经纬度反解析地址
    getAddress(longitude, latitude) {
      const that = this;
      // 创建地理编码实例, 并配置参数获取乡镇级数据
      var myGeo = new BMap.Geocoder({ extensions_town: true });
      // 根据坐标得到地址描述
      myGeo.getLocation(new BMap.Point(longitude, latitude), function (result) {
        if (result) {
          that.ruleForm.eventAddress = result.address;
        }
      });
    },
    showLoading(text) {
      this.loading = true;
      this.loadingText = text || "";
      this.$emit("showLoading", {
        text: text || "",
      });
    },
    hideLoading() {
      this.loading = false;
      this.$emit("hideLoading");
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    handleTabsEdit(targetName, action) {
      if (action === "add") {
        this.AddTable();
      }
      if (action === "remove") {
        this.RemoveTable(targetName);
      }
    },
    onGotLngLat(obj) {
      this.ruleForm.latitude = parseFloat(obj.lat);
      this.ruleForm.longitude = parseFloat(obj.lng);
      if (this.ruleForm.longitude && this.ruleForm.latitude) {
        this.getAddress(this.ruleForm.longitude, this.ruleForm.latitude);
      }
    },
    AddTable() {
      let newTabName = "report" + ++this.tabIndex;
      this.editableTabs.push({
        title: "上报信息",
        name: newTabName,
      });
      this.editableTabsValue = newTabName;
    },
    RemoveTable(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
    },
    GetEventReportList(id) {
      return list({
        current:1,
        size:2000,
        eventId:id
      })
        .then((r) => {
          r = r.data;
          var data = r.records;
          if (data && data.length > 0) {
            this.editableTabs = [];
            for (var i = 0; i < data.length; i++) {
              let newTabName = "report" + (i + 1);
              this.tabIndex = i + 1;
              var item = data[i];
              this.editableTabs.push({
                title: "上报信息",
                name: newTabName,
                reportObj: item,
              });
            }
            this.editableTabsValue = "report1";
          } else {
            this.editableTabs = [
              {
                title: "上报信息",
                name: "report1",
              },
            ];
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //事件上报
    submitReport(status) {
      // console.log(this.editableTabs); //todo
      var list = []; //上报信息list
      for (var i = 0; i < this.editableTabs.length; i++) {
        var item = this.editableTabs[i];
        var chil = this.$refs[item.name][0];
        chil.GetValidate();
        var valiret = chil.valid;
        if (valiret == "fail") {
          this.editableTabsValue = item.name;
          return;
        }
        var obj = chil.ruleForm;
        if (obj) {
          obj.eventId = this.ruleForm.id;
          list.push(obj);
        }
      }
      if (list.length > 0) {
        // 保存上报信息
        this.showLoading("保存中...");
        batchSubmit({ list, eventId: this.ruleForm.id} )
          .then((r) => {
            if (r && r.code == 0) {
              this.submitForm(status); //保存
            } else {
              this.errmsg("保存失败，请联系管理员！");
            }
            this.hideLoading();
          })
          .catch((e) => {
            console.log(e);
            this.hideLoading();
          });
      }
    },
    submitComfirm(status) {
      if (this.ruleForm.beTrue == 2) {
        status = 7;
      }
      this.ruleForm.checkTime = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
      this.submitForm(status);
    },
    //事件接报
    submitForm(status) {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.ruleForm.status = status;
          if (this.ruleForm.id == "") {
            // this.ruleForm.reportDept = this.user.deptId;
            // if (!this.ruleForm.reportDept) {
            //   this.errmsg("部门reportDept,不能为空");
            //   return;
            // }
            this.showLoading("保存中...");
            save(this.ruleForm)
              .then((r) => {
                console.log(r,'事件接报新增')
                r = r.data;
                this.$message({
                  type: "success",
                  message: r ? "保存成功！" : "保存失败！",
                });
                //this.saveMsg(this.ruleForm);
                // if (this.isAlermEvent) {
                //   this.updateAlermInfo(this.alermInfo);
                // }
                // if (this.msgInfo) {
                //   this.processMsg();
                // }
                this.hideLoading();
                //跳转到核实详情
                this.$router.push({
                  path: "/plugin/emergency/ui/ConfirmEvent",
                  query: { id: r },
                });
              })
              .catch((e) => {
                console.log(e);
                this.hideLoading();
              });
          } else {
            this.showLoading("保存中...");
            update(this.ruleForm)
              .then((r) => {
                console.log(r,'核实')
                r = r.data;
                this.$message({
                  type: "success",
                  message: r ? "保存成功！" : "保存失败！",
                });
                this.hideLoading();
                //跳转到上报详情
                if (status == 2) {
                  let id = this.ruleForm.id;
                  this.$router.push({
                    path: "/plugin/emergency/ui/ReportEvent",
                    // name: 'mallList',
                    query: { id: id },
                  });
                } else if (status == 7) {
                  this.$router.go(-1);
                }
              })
              .catch((e) => {
                console.log(e);
                this.hideLoading();
              });
          }
        }
      });
    },
    //启动
    startPlan() {
      this.dialogOpts.rowData = this.ruleForm;
      this.dialogOpts.dialogPlanTableVisible = true;
    },
    dialogPlanOk() {
      this.dialogOpts.dialogPlanTableVisible = false;
    },
    dialogPlanCancel() {
      this.dialogOpts.dialogPlanTableVisible = false;
    },
    saveMsg(ruleForm) {
      let level = "";
      if (ruleForm.eventLevel === "EmergencyEventLevel-3") {
        level = "warning_level_1";
      } else if (ruleForm.eventLevel === "EmergencyEventLevel-2") {
        level = "warning_level_2";
      } else {
        level = "warning_level_3";
      }
      let params = {
        creater: ZJApp.ZJUser.current.UserName,
        modifier: ZJApp.ZJUser.current.UserName,
        messageType: "event",
        dataTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        address: ruleForm.eventAddress,
        longitude: ruleForm.longitude,
        latitude: ruleForm.latitude,
        content: ruleForm.eventDesc,
        category: ruleForm.eventType,
        level: level,
        type: "emergency_event", // 类型(0人工处理，1、转任务， 2、转应急)
        videos: "",
        audios: "",
        images: "",
        sourceId: ruleForm.id, //关联任务id，非必传
        sourceName: "应急事件",
      };
      saveMsg(params).then((res) => {
        console.log("人工处理预警结果");
        console.log(res);
      });
    },
    //更改消息
    updateMsg() {
      let extra = { remark: "已转为应急事件" };
      const param = {
        id: this.msgInfo.id,
        // extra: JSON.stringify(extra),
        status: "1",
      };
      saveMsg(param).then((res) => {});
    },
    //更改预警信息
    updateAlermInfo(alermInfo) {
      alermInfo.FinishDate = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
      alermInfo.AcceptDate = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
      // alermInfo.ProcessConclusion = "已转为应急事件";
      if (alermInfo.AlertType == "13") {
        alermInfo.ProcessStatus = 1;
      }

      alermInfo.ProcessWay = 1;
      alermInfo.ModifyTime = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
      alermInfo.Modifier = ZJApp.ZJUser.current.UserName;
      alermInfo.eventType = "其他";
      new earlyMsgApi()
        .UpdateItem(alermInfo)
        .then((r) => {
          r = r.data.Data;

        })
        .catch((e) => {
          console.log(e);
        });
    },

    //消息转为处理
    processMsg() {
      //已处理
      this.msgInfo.status = 1;
      this.msgInfo.processResult = "转应急";

      //  this.form.uploadResouse = this.fileImgList.join(",");
      process(this.msgInfo)
        .then((r) => {
          r = r.code;
       
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          //this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    isJson(str) {
      if (typeof str == "string") {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == "object" && obj) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          return false;
        }
      }
    },
    time(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
    },
  },
  created: function () {
    this.init();
  },
};
</script>
<style>
.eventinfocss .el-input {
  width: 40rem;
}
.eventinfocss .el-textarea {
  width: 98rem;
}
.eventinfocss .el-date-editor {
  width: 40rem;
}
.eventinfocss .button-container {
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.el-collapse .el-collapse-item .el-collapse-item__header {
  background-color: #0f3f6f;
  padding-left: 25px;
  border: none;
}
.el-collapse-item__content {
  padding-top: 25px;
  padding-bottom: 15px;
}
.spantitle {
  padding-left: 10px;
}
.el-collapse-item__wrap {
  will-change: height;
  background-color: #ffffff;
  overflow: hidden;
  box-sizing: border-box;
  border: none;
}
.el-collapse {
  border: none;
}
.el-tabs__new-tab {
  margin-right: 20px;
  width: 40px;
  height: 20px;
}
</style>
